// Gemeinsame Farben für Karte, Legende, Gebietsliste und Zeitstrahl.
// Herstellerfarben nach den offiziellen Quellen (geprüft am 11.10.2026):
// Bosch-Logo: https://www.bosch.com/ – Rot #ED0007.
// Siemens: https://element.siemens.io/v49/fundamentals/colors/color-palette/ – Petrol #009999.
// Mehrere Konzessionäre erhalten Violett, um sie von Siemens zu unterscheiden.
// „Sonstige“ ist bewusst neutral (Sammelkategorie), „ohne Angabe“ hohl,
// „keine Fassung“ klein und blass – Identität nie allein über Farbe (Form, Legende, Liste).
import type { Kategorie } from './daten/zeitreihe.js';

export const OBERFLAECHE = '#fcfcfb';

export interface KategorieStil {
  label: string;
  fuellung: string;
  rand: string;
  radius: number;
  deckkraft: number;
}

export const KATEGORIE_STIL: Record<Kategorie, KategorieStil> = {
  bosch: { label: 'Bosch', fuellung: '#ed0007', rand: '#ffffff', radius: 6, deckkraft: 1 },
  siemens: { label: 'Siemens', fuellung: '#009999', rand: '#ffffff', radius: 6, deckkraft: 1 },
  mehrere: { label: 'Mehrere Konzessionäre', fuellung: '#7c3aed', rand: '#ffffff', radius: 6, deckkraft: 1 },
  sonstige: { label: 'Sonstiger Konzessionär', fuellung: '#52514e', rand: '#ffffff', radius: 5, deckkraft: 1 },
  ohne_angabe: { label: 'Kein Konzessionär erkannt', fuellung: '#ffffff', rand: '#57534e', radius: 5, deckkraft: 1 },
  keine_fassung: { label: 'Keine TAB-Fassung bekannt', fuellung: '#a8a29e', rand: '#ffffff', radius: 3, deckkraft: 0.6 },
};

export const KATEGORIE_REIHENFOLGE: Kategorie[] = [
  'bosch',
  'siemens',
  'mehrere',
  'sonstige',
  'ohne_angabe',
  'keine_fassung',
];

// Ordinale Blaurampe für die Skala 0–5 (Stufen 250–700 der Referenzrampe;
// hellste Stufe ≥ 2:1 gegen die Oberfläche).
export const SKALA_FARBEN = ['#86b6ef', '#5598e7', '#3987e5', '#256abf', '#184f95', '#0d366b'] as const;
export const SKALA_OFFEN = { fuellung: '#ffffff', rand: '#a8a29e' } as const;
